import { Transaction, VersionedTransaction } from '@exodus/solana-web3.js';
class VersionedTransactionUnsupportedError extends Error {
    constructor() {
        super('Versioned transactions are not supported.');
        this.name = 'VERSIONED_TRANSACTION_UNSUPPORTED';
    }
}
export const SUPPORTED_TRANSACTION_VERSIONS = new Set(['legacy', 0]);
export function serializeTransactionAsBytes(transaction) {
    if (isLegacyTransaction(transaction)) {
        return Buffer.from(transaction.serialize({ requireAllSignatures: false }));
    }
    return Buffer.from(transaction.serialize());
}
export function serializeTransaction(transaction) {
    return serializeTransactionAsBytes(transaction).toString('base64');
}
export function deserializeTransactionBytes(wireTransactionBuffer) {
    try {
        return Transaction.from(wireTransactionBuffer);
    }
    catch {
        if (!VersionedTransaction) {
            throw new VersionedTransactionUnsupportedError();
        }
        return VersionedTransaction.deserialize(Uint8Array.from(wireTransactionBuffer));
    }
}
export function deserializeTransaction(wireTransaction) {
    const wireTransactionBuffer = Buffer.from(wireTransaction, 'base64');
    return deserializeTransactionBytes(wireTransactionBuffer);
}
export function isLegacyTransaction(transaction) {
    return !Number.isInteger(transaction.version);
}
export function applySignatures(transaction, signedTransaction) {
    transaction.signatures = signedTransaction.signatures; // eslint-disable-line @exodus/mutable/no-param-reassign-prop-only
}
export function normalizeSignAndSendAllTransactionInputs(inputs, sendOptions) {
    return inputs.map((input) => {
        if ('transaction' in input) {
            return input;
        }
        return { transaction: input, options: sendOptions };
    });
}
export const getSignerPublicKey = (transaction, accounts) => {
    if (isLegacyTransaction(transaction)) {
        const keys = transaction.instructions.flatMap((instruction) => instruction.keys);
        const signer = keys.find((key) => key.isSigner && accounts.includes(key.pubkey.toBase58()));
        return signer?.pubkey;
    }
    return transaction.message.staticAccountKeys.find((key) => accounts.includes(key.toBase58()));
};
export function isRawTransaction(transaction) {
    return transaction instanceof Uint8Array;
}
